module.exports = __webpack_public_path__ + "static/images/ten-video.024e31a.png";